/* ==========================================================================
   Sparkle Finds SA — storefront behaviour on Shopify

   Port of the add-to-cart, toast and cart-count behaviour from the approved
   design's app.js. The design kept its cart in localStorage; here the same
   interactions run against Shopify's real cart via /cart/add.js and
   /cart/change.js, so the markup and wording are unchanged but the state is
   real.

   One-off products are added once and their button then reads "In your
   cart", as the design specifies.

   CLIENT REQUEST (Sulé, 11 Sep 2026): the Surprise Cube is one product with
   a variant per ring size and can be bought several at a time. Its buttons
   carry data-sf-repeat and stay "Add to cart"; the product page adds a size
   picker and quantity control; the cart gets quantity controls per line.
   ========================================================================== */

(function () {
  "use strict";

  var CART_URL = window.SF_ROUTES && window.SF_ROUTES.cart ? window.SF_ROUTES.cart : '/cart';

  /* ---- toast --------------------------------------------------------- */
  var toastTimer;

  /* Text is set with textContent so a product title can never inject markup;
     the "View cart" link is built as an element. */
  function showToast(text, withCartLink) {
    var toast = document.getElementById('toast');
    if (!toast) { return; }
    toast.textContent = text;
    if (withCartLink) {
      var link = document.createElement('a');
      link.href = CART_URL;
      link.textContent = 'View cart';
      toast.appendChild(document.createTextNode(' '));
      toast.appendChild(link);
    }
    toast.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 3600);
  }

  /* ---- cart count ---------------------------------------------------- */
  function paintCartCount(count) {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-cart-count]'),
      function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      }
    );
  }

  function refreshCartCount() {
    return fetch(window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root + 'cart.js'
      : '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { paintCartCount(cart.item_count); return cart; })
      .catch(function () { /* leave the server-rendered count alone */ });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) { return response.json().then(function (e) { throw e; }); }
      return response.json();
    });
  }

  function addItems(variantId, quantity) {
    return postJSON('/cart/add.js', { items: [{ id: Number(variantId), quantity: quantity }] });
  }

  /* ---- swap a one-off product's button to its "in cart" state --------- */
  function markInCart(button) {
    var variantId = button.getAttribute('data-sf-add');

    /* The same product can have more than one buy button on a page — the one
       in the product info and the one in the sticky mobile buy bar. The
       design repaints both, so swap every button for this variant. */
    var buttons = document.querySelectorAll('[data-sf-add="' + variantId + '"]');
    Array.prototype.forEach.call(buttons, function (btn) {
      var link = document.createElement('a');
      link.className = btn.className.replace('btn--primary', 'btn--ghost');
      link.href = CART_URL;
      link.textContent = 'In your cart';
      btn.replaceWith(link);
    });

    /* The design drops "Buy it now" once a one-off is in the cart. */
    var buyNow = document.querySelector('[data-sf-buy="' + variantId + '"]');
    if (buyNow) { buyNow.remove(); }
  }

  /* ---- the Surprise Cube buy panel (size + quantity) ------------------- */
  function cubePanel(from) {
    return (from && from.closest('[data-sf-cube]')) || document.querySelector('[data-sf-cube]');
  }

  function selectedSize(panel) {
    return panel ? panel.querySelector('.sf-size.is-selected') : null;
  }

  function panelQty(panel) {
    var out = panel && panel.querySelector('[data-sf-qty-value]');
    var n = out ? parseInt(out.textContent, 10) : 1;
    return n > 0 ? n : 1;
  }

  /* Keep the quantity between 1 and the stock of the chosen size. Untracked
     sizes have no data-max, so they cap at 10 to stop accidental huge adds. */
  function clampQty(panel) {
    if (!panel) { return; }
    var out = panel.querySelector('[data-sf-qty-value]');
    if (!out) { return; }
    var size = selectedSize(panel);
    var max = size && parseInt(size.getAttribute('data-max'), 10);
    if (!(max > 0)) { max = 10; }
    var n = Math.min(Math.max(panelQty(panel), 1), max);
    out.textContent = n;
    var less = panel.querySelector('[data-sf-qty-step="-1"]');
    var more = panel.querySelector('[data-sf-qty-step="1"]');
    if (less) { less.disabled = n <= 1; }
    if (more) { more.disabled = n >= max; }
  }

  function selectSize(button) {
    var panel = cubePanel(button);
    if (!panel || button.disabled) { return; }
    Array.prototype.forEach.call(panel.querySelectorAll('.sf-size'), function (b) {
      var on = b === button;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-pressed', String(on));
    });

    var id = button.getAttribute('data-sf-size');
    Array.prototype.forEach.call(document.querySelectorAll('[data-sf-cube-add]'), function (b) {
      if (b.hasAttribute('data-sf-add')) { b.setAttribute('data-sf-add', id); }
      if (b.hasAttribute('data-sf-buy')) { b.setAttribute('data-sf-buy', id); }
      b.disabled = false;
    });
    clampQty(panel);

    var image = button.getAttribute('data-image');
    var main = document.getElementById('galleryMain');
    if (image && main) { main.src = image; }

    if (window.history && window.history.replaceState && window.URL) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      window.history.replaceState(null, '', url.toString());
    }
  }

  function stepQty(button) {
    var panel = cubePanel(button);
    var out = panel && panel.querySelector('[data-sf-qty-value]');
    if (!out) { return; }
    out.textContent = panelQty(panel) + Number(button.getAttribute('data-sf-qty-step'));
    clampQty(panel);
  }

  /* ---- add to cart --------------------------------------------------- */
  function addToCart(button) {
    var variantId = button.getAttribute('data-sf-add');
    var name = button.getAttribute('data-sf-name') || 'Cube';
    if (!variantId || button.disabled) { return; }

    var quantity = 1;
    if (button.hasAttribute('data-sf-cube-add')) {
      var panel = cubePanel(button);
      quantity = panelQty(panel);
      var size = selectedSize(panel);
      if (size) { name += ', ' + size.getAttribute('data-sf-size-label'); }
    }

    button.disabled = true;

    addItems(variantId, quantity)
      .then(function () {
        if (button.hasAttribute('data-sf-repeat')) {
          button.disabled = false;
        } else {
          markInCart(button);
        }
        showToast((quantity > 1 ? quantity + ' × ' : '') + name + ' added.', true);
        return refreshCartCount();
      })
      .catch(function (err) {
        button.disabled = false;
        showToast((err && err.description) || 'That cube could not be added.');
      });
  }

  /* ---- buy it now ------------------------------------------------------
     The design adds the cube then goes straight to checkout. Same here.
     --------------------------------------------------------------------- */
  function buyNow(button) {
    var variantId = button.getAttribute('data-sf-buy');
    if (!variantId || button.disabled) { return; }

    var quantity = button.hasAttribute('data-sf-cube-add') ? panelQty(cubePanel(button)) : 1;
    button.disabled = true;

    addItems(variantId, quantity)
      .then(function () { window.location.href = '/checkout'; })
      .catch(function (err) {
        button.disabled = false;
        showToast((err && err.description) || 'That cube could not be added.');
      });
  }

  /* ---- product gallery -------------------------------------------------
     Ported from the thumbnail handler in initProduct().
     --------------------------------------------------------------------- */
  function initGallery() {
    var thumbs = document.getElementById('galleryThumbs');
    var main = document.getElementById('galleryMain');
    if (!thumbs || !main) { return; }

    var buttons = Array.prototype.slice.call(thumbs.querySelectorAll('button[data-index]'));
    if (!buttons.length) { return; }

    var index = Math.max(0, buttons.findIndex(function (b) {
      return b.getAttribute('aria-pressed') === 'true';
    }));

    function show(next) {
      index = Math.max(0, Math.min(buttons.length - 1, next));
      var button = buttons[index];
      main.src = button.getAttribute('data-full');
      buttons.forEach(function (other) {
        other.setAttribute('aria-pressed', String(other === button));
      });
      syncArrows();
    }

    /* Arrows are an addition beyond the approved design. They stop at each
       end rather than wrapping, so the thumbnail strip stays the source of
       truth for where you are in the gallery. */
    function syncArrows() {
      var prev = document.querySelector('[data-sf-gallery="prev"]');
      var next = document.querySelector('[data-sf-gallery="next"]');
      if (prev) { prev.disabled = index === 0; }
      if (next) { next.disabled = index === buttons.length - 1; }
    }

    thumbs.addEventListener('click', function (event) {
      var button = event.target.closest('button[data-index]');
      if (!button) { return; }
      show(buttons.indexOf(button));
    });

    document.addEventListener('click', function (event) {
      var arrow = event.target.closest('[data-sf-gallery]');
      if (!arrow) { return; }
      show(index + (arrow.getAttribute('data-sf-gallery') === 'next' ? 1 : -1));
    });

    syncArrows();
  }

  /* ---- change or remove a cart line -------------------------------------
     The design repaints the cart in place. Shopify's Section Rendering API
     gives the same result: change the line, get the section back rendered,
     swap it in. No full page reload.
     --------------------------------------------------------------------- */
  function changeLine(key, quantity, control) {
    var container = document.getElementById('cart');
    var sectionId = container && container.getAttribute('data-sf-cart-section');
    if (!key) { return; }
    if (control) { control.disabled = true; }

    postJSON('/cart/change.js', { id: key, quantity: quantity, sections: sectionId })
      .then(function (cart) {
        paintCartCount(cart.item_count);

        var markup = cart.sections && cart.sections[sectionId];
        if (!markup) { window.location.reload(); return; }

        var parsed = new DOMParser().parseFromString(markup, 'text/html');
        var fresh = parsed.getElementById('cart');
        if (fresh && container) {
          container.replaceWith(fresh);
        } else {
          window.location.reload();
        }
      })
      .catch(function (err) {
        if (control) { control.disabled = false; }
        showToast((err && err.description) || 'That cart line could not be updated.');
      });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;

    var remove = target.closest('[data-sf-remove]');
    if (remove) {
      event.preventDefault();
      changeLine(remove.getAttribute('data-sf-remove'), 0, remove);
      return;
    }

    var lineStep = target.closest('[data-sf-line-step]');
    if (lineStep) {
      event.preventDefault();
      var next = Number(lineStep.getAttribute('data-sf-line-qty')) + Number(lineStep.getAttribute('data-sf-line-step'));
      changeLine(lineStep.getAttribute('data-sf-line-key'), Math.max(0, next), lineStep);
      return;
    }

    var qtyStep = target.closest('[data-sf-qty-step]');
    if (qtyStep) {
      event.preventDefault();
      stepQty(qtyStep);
      return;
    }

    var size = target.closest('[data-sf-size]');
    if (size) {
      event.preventDefault();
      selectSize(size);
      return;
    }

    /* The sticky mobile buy bar adds whatever is chosen in the panel above. */
    var bar = target.closest('[data-sf-cube-bar]');
    if (bar) {
      event.preventDefault();
      var main = document.querySelector('[data-sf-cube] [data-sf-add]');
      if (main) { main.click(); }
      return;
    }

    var add = target.closest('[data-sf-add]');
    if (add) {
      event.preventDefault();
      addToCart(add);
      return;
    }

    var buy = target.closest('[data-sf-buy]');
    if (buy) {
      event.preventDefault();
      buyNow(buy);
    }
  });

  function init() {
    initGallery();
    clampQty(document.querySelector('[data-sf-cube]'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
